export const Seventeen='6';